module.exports = __webpack_public_path__ + "media/icons/arrow-purple-037c0c81.png";